import React from 'react'
import styled from 'styled-components'
import Footer from './components/Footer'
import { Main } from './pages'

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	min-height: 100vh;

	.content {
		flex: 1;
	}
`
const App = () => {
	return (
		<Wrapper>
			<Main className="content"/>
			<Footer/>
		</Wrapper>

	)
}

export default App